module.exports = __webpack_public_path__ + "static/media/Icon-1024.49e813b4.png";